import React from 'react'
import ProfileItemForm from "./ProfileItemForm";
import { Checkbox, Input } from "antd";
import SearchBrandsInput from "../../../components/form/SearchBrandsInput";
import { FormInputComponent } from "../../../components/form/Form";
import { TalentAppCard } from './TalentAppCard';

export default class BrandForm extends ProfileItemForm {

    static ItemType = 'Brand'

    static FormClass = 'talent-role-form talent-interest-form add-talent-form '

    static shouldUseTalentAppCard = true;

    static TypeConfig = {
        icon: 'fas fa-handshake',
        color: '#aaacad'
    }

    // canEdit() {
    //     return false;
    // }

    getModelFromProps() {
        if (!TB.keys(TB.tryObject(this.props.model || {})).length) return {};
        return { brand: (this.props.model || {}) };
    }

    /**
     * Handles form change
     *
     * @returns void
     */
    onChange(model) {
        let selectedId = model.brand?.brandId || model.brand?.brandId;

        let brandsIds = TB.map((this.props.user.brands || []), 'id');

        model.is_custom = !!model.is_custom;
        if (model.is_custom) {
            model.brand = undefined;
        }

        if (this.getModelFromProps().brand?.id) {
            brandsIds = TB.filter(brandsIds, id => id !== this.getModelFromProps()?.brand?.id);
        }
        if (selectedId && brandsIds.length && brandsIds.includes(selectedId)) {
            this.formRef.current.forceValidate();
        }

        console.log('onChange', model)

        return this.setState({ model })
    }

    /**
     * Handles form submit button clicks when form is valid
     *
     * @returns void
     */
    onSubmit() {
        let model = {
            ...this.state.model,
            ...this.getModelFromProps()?.brand,
            ...this.state.model?.brand
        };

        if (!model?.id || !model.display_index) {
            let lastBrand = TB.first(
                TB.orderBy(
                    TB.filter(this.props.user.brands || [], brand => TB.isDefined(brand.display_index)), 'display_index',
                    'desc'
                ));
            if (!!lastBrand?.display_index) {
                model.display_index = lastBrand.display_index + 1;
            } else model.display_index = 1;
        }

        console.log(model, 'MODEL ON SUBMIT')
        return super.onSubmit(model);
    }
    /**
     * The fields mapping for the form
     */
    formFields_LEGACY = () => {

        const fields = [
            {
                style: { ...styles.fieldSection, alignItems: 'flex-end' },
                fields: {
                    brand: {
                        className: 'search-brand-input [&>.form-group]:mb-0',
                        style: styles.field,
                        component: (
                            <FormInputComponent
                                type="antd-input"
                                fieldName="brand"
                                label={false}
                                required={!this.state.model.is_custom}
                                value={this.state.model.brand}
                            >
                                <SearchBrandsInput isDisabled={this.state.model?.is_custom} />
                            </FormInputComponent>
                        )
                    },
                    is_custom: {
                        component: (
                            <FormInputComponent
                                type="antd-input"
                                fieldName="is_custom"
                                label="Don’t see your brand listed?"
                                labelClassName="pt-0 mb-0.5"
                                value={this.state.model?.is_custom}
                            >
                                <Checkbox checked={this.state.model?.is_custom}>
                                    Add Custom Brand
                                </Checkbox>
                            </FormInputComponent>
                        )
                    }
                }
            },
        ];

        if (this.state.model?.is_custom) {
            fields.push({
                fields: {
                    name: {
                        type: 'text',
                        required: true,
                    },
                    domain: {
                        label: 'Domain (Include https://)',
                        type: 'url',
                        required: true,
                    },
                    icon: {
                        label: 'Logo',
                        type: 'file',
                        required: true,
                    }
                },
            })
        }

        return fields;
    };

    renderTitle() {
        return null;
    }

    renderFormFields() {
        const { isEditing } = this.props;
        const { brand } = this.state.model;

        // only show form if editing (creating a new brand) and brand doesnt exist
        if (isEditing && !brand?.id) {
            return (
                <TalentAppCard.Section>
                    {this.renderFormData()}
                </TalentAppCard.Section>
            )
        }

        return (
            <TalentAppCard.Section>
                {this.renderFormattedData()}
            </TalentAppCard.Section>
        )
    }

    renderFormData = () => {
        return (
            <div className="field-section">
                <div className="flex flex-col sm:flex-row items-start sm:items-end gap-4">
                    <div className="flex-1 w-full search-brand-input [&>.form-group]:mb-0">
                        <FormInputComponent
                            type="antd-input"
                            fieldName="brand"
                            label={false}
                            required={!this.state.model.is_custom}
                            value={this.state.model.brand}
                        >
                            <SearchBrandsInput isDisabled={this.state.model?.is_custom || this.props.disabled} />
                        </FormInputComponent>
                    </div>
                    <div className="[&_.form-group]:mb-0 field-element">
                        <FormInputComponent
                            type="antd-input"
                            fieldName="is_custom"
                            label="Don't see your brand listed?"
                            labelClassName="pt-0 mb-0.5"
                            value={this.state.model?.is_custom}
                        >
                            <Checkbox checked={this.state.model?.is_custom}>
                                Add Custom Brand
                            </Checkbox>
                        </FormInputComponent>
                    </div>
                </div>

                {this.state.model?.is_custom && (
                    <div className="flex flex-col gap-4 pt-4">
                        <FormInputComponent
                            type="antd-input"
                            fieldName="name"
                            required
                            value={this.state.model.name}
                        >
                            <Input
                                placeholder="Brand Name"
                                disabled={this.props.disabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                        <FormInputComponent
                            type="antd-input"
                            fieldName="domain"
                            label="Domain (Include https://)"
                            required
                            value={this.state.model.domain}
                            validation={{
                                rules: {
                                    matchRegexp: /^(http|https):\/\//,
                                    isUrl: true,
                                },
                                errors: {
                                    matchRegexp: 'Must start with http(s)://',
                                    isUrl: TB.trans('validation.active_url', {
                                        'attribute': 'domain',
                                    }),
                                }
                            }}
                        >
                            <Input
                                placeholder="https://example.com"
                                disabled={this.props.disabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                        <FormInputComponent
                            fieldName="icon"
                            label="Logo"
                            type="file"
                            required
                            value={this.state.model.icon}
                        />
                    </div>
                )}
            </div>
        )
    }

    renderFormattedData() {
        const brand = this.state.model?.brand || {};
        const name = brand.name || this.state.model?.name;
        const icon = brand.logo || brand.icon || this.state.model?.icon;
        const domain = brand.domain || this.state.model?.domain;

        return (
            <>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                    {icon && (
                        <div className="shrink-0">
                            <img
                                src={icon}
                                alt={`${name} logo`}
                                className="h-[90px] w-[90px] rounded object-contain"
                            />
                        </div>
                    )}
                    <div className="flex flex-col sm:flex-row flex-wrap gap-x-8 gap-y-2 flex-1 min-w-0">
                        <div className="min-w-0">
                            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-0.5">Brand</p>
                            <p className="text-sm font-medium m-0 truncate">{name || '—'}</p>
                        </div>
                        {domain && (
                            <div className="min-w-0">
                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-0.5">Website</p>
                                <a href={domain} target="_blank" rel="noopener noreferrer" className="text-sm text-primary hover:underline truncate block">
                                    {domain}
                                </a>
                            </div>
                        )}
                    </div>
                </div>

                {this.props.isEditing && (
                    <p className="text-xs text-center text-orange-600 pt-6 -mb-4">To change this brand, delete it and add a brand below</p>
                )}
            </>
        )
    }

    renderFormFooterInfo() {
        return <div />
    }

    renderEditFormButton() {
        return (
            <button
                className="btn btn-primary px-6"
                disabled={this.props.disabled}
                type="button" onClick={() => this.props.onEditing(true)}
            >
                Edit Brand
            </button>
        );
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};